import { z } from 'zod/v4'
import { WorkflowNodeBaseSchema } from '../../../resources/types'

const ThreadSignalCreateInputsSchema = z.object({
  'thread-id': z.string().describe('Thread to add the signal to'),
  description: z
    .string()
    .describe(
      'Short signal description shown before "via" and the app, e.g. "Booked an appointment"',
    ),
  'app-handle': z
    .string()
    .describe('App handle used to resolve app icon and display name'),
  handle: z
    .string()
    .optional()
    .describe(
      'Stable signal handle for routing (e.g. member-signed-up). Used by thread.signal.created event subscriptions to filter signals.',
    ),
  metadata: z
    .record(z.string(), z.unknown())
    .optional()
    .describe(
      'Additional signal payload stored on the thread block (event data, IDs, etc.)',
    ),
})

const ThreadSignalCreateOptionsSchema = z.object({})

export const ThreadSignalCreateCommandSchema = WorkflowNodeBaseSchema.extend({
  service: z.object({
    name: z.literal('skedyul/threads'),
    cmd: z.literal('signal.create'),
    options: ThreadSignalCreateOptionsSchema.optional(),
  }),
  inputs: ThreadSignalCreateInputsSchema,
})

export type ThreadSignalCreateCommand = z.infer<
  typeof ThreadSignalCreateCommandSchema
>
